import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { CashRegisterClosureList } from '../../shared/models/sale/cash-register-closure-list.model';
import { CashRegisterClosure } from '../../shared/models/sale/cash-register-closure.model';
import { CashMovement } from '../../shared/models/sale/cash-movement.model';
import { CloseCashRegisterClosureDto } from '../../shared/dtos/sale/close-cash-register-closure.dto';
import { OpenCashRegisterClosureDto } from '../../shared/dtos/sale/open-cash-registerC-closure.dto';

export const cashRegisterClosureApi = createApi({
  reducerPath: 'cashRegisterClosureApi',
  baseQuery,
  tagTypes: ['CashRegisterClosures'],
  endpoints: (builder) => ({
    getCashRegisterClosures: builder.query<IPagedResult<CashRegisterClosureList>, string>({
      query: (filterSet) => ({
        url: `/api/cashclosing?${filterSet}`,
        method: 'GET',
      }),
      providesTags: ['CashRegisterClosures'],
    }),
    getCashRegisterClosure: builder.query<CashRegisterClosure, string>({
      query: (id) => ({
        url: `/api/cashclosing/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'CashRegisterClosures', id }],
    }),
    openCashRegisterClosure: builder.mutation<
      CashRegisterClosure,
      Partial<OpenCashRegisterClosureDto>
    >({
      query: (values) => ({
        url: `/api/cashclosing/open`,
        method: 'POST',
        body: values,
      }),
      invalidatesTags: [{ type: 'CashRegisterClosures', id: 'LIST' }],
    }),
    closeCashRegisterClosure: builder.mutation<
      CashRegisterClosure,
      Partial<CloseCashRegisterClosureDto>
    >({
      query: (values) => ({
        url: `/api/cashclosing/close`,
        method: 'POST',
        body: values,
      }),
      invalidatesTags: [{ type: 'CashRegisterClosures', id: 'LIST' }],
    }),
    exportCashRegisterClosure: builder.query<Blob, string>({
      query: (id) => ({
        url: `/api/cashclosing/${id}/:exportAsXslx`,
        method: 'GET',
        responseHandler: async (response) => response.blob(),
        cache: 'no-cache',
      }),
    }),
    addCashMovement: builder.mutation<CashMovement, Partial<CashMovement>>({
      query: (values) => ({
        url: `/api/cashclosing/movement`,
        method: 'POST',
        body: values,
      }),
      invalidatesTags: [{ type: 'CashRegisterClosures', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetCashRegisterClosuresQuery,
  useLazyGetCashRegisterClosuresQuery,
  useGetCashRegisterClosureQuery,
  useLazyGetCashRegisterClosureQuery,
  useOpenCashRegisterClosureMutation,
  useAddCashMovementMutation,
  useCloseCashRegisterClosureMutation,
  useLazyExportCashRegisterClosureQuery,
} = cashRegisterClosureApi;
